<template>
  <div>
    <div class="inline-flex items-center space-x-3 cursor-pointer text-text-label hover:text-red group"
         @click="isOpened = !isOpened">
      <IconQuestionMark class="text-red"/>
      <span class="text-sm border-b border-dashed border-border-hover group-hover:border-red transition duration-200">Как получить отчет брокера?</span>
      <IconChevronSm class="text-border-hover mt-1"/>
    </div>
    <TransitionCollapseHeight>
      <div v-if="isOpened">
        <div class="mt-8 border-l border-red ml-3 pl-6 text-md text-text">
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta nam non repellendus rerum, tempore vel. Debitis doloremque dolores doloribus eveniet impedit, ipsa molestiae, molestias placeat possimus repellendus sunt vitae!</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta nam non repellendus rerum, tempore vel. Debitis doloremque dolores doloribus eveniet impedit, ipsa molestiae, molestias placeat possimus repellendus sunt vitae!</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta nam non repellendus rerum, tempore vel. Debitis doloremque dolores doloribus eveniet impedit, ipsa molestiae, molestias placeat possimus repellendus sunt vitae!</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta nam non repellendus rerum, tempore vel. Debitis doloremque dolores doloribus eveniet impedit, ipsa molestiae, molestias placeat possimus repellendus sunt vitae!</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta nam non repellendus rerum, tempore vel. Debitis doloremque dolores doloribus eveniet impedit, ipsa molestiae, molestias placeat possimus repellendus sunt vitae!</p>
        </div>
      </div>
    </TransitionCollapseHeight>
  </div>
</template>

<script>
import IconQuestionMark from "@/components/icons/IconQuestionMark";
import IconChevronSm from "@/components/icons/IconChevronSm";
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";

export default {
  name: "HowGetReportInfo",
  data() {
    return {
      isOpened: false
    }
  },
  components: {TransitionCollapseHeight, IconChevronSm, IconQuestionMark}
}
</script>